"use strict";
var Observable_1 = require('../../Observable');
var every_1 = require('../../operator/every');
Observable_1.Observable.prototype.every = every_1.every;
//# sourceMappingURL=every.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/every.js